export interface IMORTGAGE_FORMULA {
  loanAmount: number | undefined;
  rateOfInterest: number | undefined;
  loanTenure: number | undefined;
}

export const MORTGAGE_FORMULA = ({
  loanAmount,
  rateOfInterest,
  loanTenure,
}: IMORTGAGE_FORMULA) => {
  if (
    !loanAmount ||
    !rateOfInterest ||
    !loanTenure ||
    Number(loanAmount) < 0 ||
    Number(rateOfInterest) < 0 ||
    Number(loanTenure) < 0
  ) {
    return {
      monthlyEmi: 0,
      totalAmountPayable: 0,
      interestComponent: 0,
    };
  }

  const monthlyInterestRate = rateOfInterest / (12 * 100);
  const totalPayments = loanTenure * 12;

  // The formula for calculating EMI is:
  // EMI = [P * R * (1+R)^N] / [(1+R)^N - 1]
  // where P is the loan amount, R is the monthly interest rate, N is the number of monthly installments.
  const emi =
    (loanAmount *
      monthlyInterestRate *
      Math.pow(1 + monthlyInterestRate, totalPayments)) /
    (Math.pow(1 + monthlyInterestRate, totalPayments) - 1);

  const monthlyEmi = parseFloat(emi.toFixed(10));

  // The total amount payable over the loan tenure is the EMI * number of payments
  const totalAmountPayable = monthlyEmi * totalPayments;

  // The interest component is the total amount payable minus the loan amount
  const interestComponent = totalAmountPayable - loanAmount;

  return {
    monthlyEmi: Math.round(monthlyEmi),
    totalAmountPayable: Math.round(totalAmountPayable),
    loanAmoun: Math.round(loanAmount),
    interestComponent: Math.round(interestComponent),
  };
};
